(() => {
  'use strict';
  document.querySelectorAll('[data-emf-native-product]').forEach(root => {
    const select = root.querySelector('[data-native-variant]');
    const price = root.querySelector('[data-native-price]');
    const image = root.querySelector('[data-native-image]');
    const quantity = root.querySelector('[data-native-quantity]');
    const submit = root.querySelector('[data-native-add]');
    const collectionLink = root.querySelector('[data-native-collection-link]');
    if (!select || !price || !image || !quantity || !submit) return;
    const update = (updateUrl) => {
      const option = select.selectedOptions[0];
      if (!option) { submit.disabled = true; return; }
      price.textContent = option.dataset.price || '';
      submit.disabled = option.disabled;
      submit.textContent = option.disabled ? root.dataset.soldLabel : root.dataset.addLabel;
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      const minimum = Number(quantity.min), increment = Number(quantity.step);
      let count = Math.max(minimum, Number(quantity.value) || minimum);
      count = minimum + Math.ceil((count - minimum) / increment) * increment;
      if (quantity.max) count = Math.min(count, Number(quantity.max));
      quantity.value = String(count);
      if (updateUrl) {
        const womenMissing = option.dataset.missingWomen === 'true';
        image.replaceChildren();
        if (womenMissing || !option.dataset.image) {
          const message = document.createElement('p');
          message.textContent = womenMissing ? root.dataset.womenImage : root.dataset.unavailableImage;
          image.append(message);
        } else {
          const img = document.createElement('img');
          img.src = option.dataset.image;
          img.alt = option.dataset.imageAlt || '';
          img.width = 1400;
          img.height = 1400;
          image.append(img);
        }
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState(history.state, '', url.href);
      }
      if (collectionLink) {
        const url = new URL(collectionLink.href, location.href);
        const unsupportedCollectionFit = false;
        collectionLink.hidden = unsupportedCollectionFit;
        url.searchParams.set('emf_fit', unsupportedCollectionFit ? 'Men' : option.dataset.fit || 'Men');
        collectionLink.href = url.href;
      }
    };
    select.addEventListener('change', () => update(true));
    update(false);
  });
})();
